"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchCorrectionCard = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var luxon_1 = require("luxon");
var DateManagement_1 = require("../../utils/DateManagement");
var Col_1 = require("@amzn/atoz-web/Col");
var Row_1 = require("@amzn/atoz-web/Row");
var Text_1 = require("@amzn/atoz-web/Text");
var Responsive_1 = require("@amzn/atoz-web/Responsive");
var Button_1 = require("@amzn/atoz-web/Button");
var Modal_1 = require("@amzn/atoz-web/Modal");
var Theme_1 = require("@amzn/atoz-web/Theme");
var PunchCorrectionCard = function (_a) {
    var correctionDateTime = _a.correctionDateTime, correctionId = _a.correctionId, renderPunchModal = _a.renderPunchModal, renderPunchCorrectionConfirmationModal = _a.renderPunchCorrectionConfirmationModal, militaryTime = _a.militaryTime, cardIndex = _a.cardIndex;
    var t = (0, react_i18next_1.useTranslation)().t;
    var matches = (0, Responsive_1.useBreakpoints)().matches;
    var punchCorrectionDateTime = luxon_1.DateTime.fromISO(correctionDateTime);
    var punchCorrectionTime = (0, DateManagement_1.getTimeString)(punchCorrectionDateTime, militaryTime).toLocaleLowerCase();
    var punchCorrectionDate = punchCorrectionDateTime
        .toFormat('LLL d')
        .toLocaleUpperCase();
    return (react_1.default.createElement(react_1.default.Fragment, { key: correctionId },
        react_1.default.createElement(Row_1.Row, { dataTestId: "missed-punch-correction-row-".concat(correctionId), justifyContent: "space-between", margin: { top: 'S200', bottom: 'S200' }, gridGap: matches.s ? 'S200' : 'S400' },
            react_1.default.createElement(Col_1.Col, { flex: "1" },
                react_1.default.createElement(Text_1.Text, { color: "neutral70", fontSize: "T200" }, t('time_and_attendance_PunchCorrectionCard_CorrectionsMissedPunchIndex', {
                    number: cardIndex + 1
                })),
                react_1.default.createElement(Row_1.Row, { alignItems: "end", gridGap: "S200" },
                    react_1.default.createElement(Text_1.Text, { fontSize: "T400", fontWeight: "bold", dataTestId: "punch-correction-time-".concat(cardIndex) }, punchCorrectionTime),
                    react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T200", dataTestId: "punch-correction-date-".concat(cardIndex) }, punchCorrectionDate))),
            react_1.default.createElement(Col_1.Col, { justifyContent: "center" },
                react_1.default.createElement(Row_1.Row, { alignItems: "center", justifyContent: "flex-end", gridGap: "S200", padding: "S200" },
                    react_1.default.createElement(Modal_1.WithModal, { renderModal: renderPunchModal }, function (_a) {
                        var open = _a.open;
                        return (react_1.default.createElement(StyledButton, { key: "PunchCorrectionCardEditButton", variant: Button_1.ButtonVariant.Secondary, onClick: open, dataTestId: "PunchCorrectionCardEdit", "aria-label": t('time_and_attendance_PunchCorrectionCard_CorrectionsEdit_ariaLabel', {
                                date: punchCorrectionDate,
                                time: punchCorrectionTime
                            }) }, t('time_and_attendance_PunchCorrectionCard_CorrectionsEdit')));
                    }),
                    react_1.default.createElement(Modal_1.WithModal, { renderModal: renderPunchCorrectionConfirmationModal }, function (_a) {
                        var open = _a.open;
                        return (react_1.default.createElement(StyledButton, { key: "PunchCorrectionCardConfirmnButton", variant: Button_1.ButtonVariant.Primary, onClick: open, dataTestId: "PunchCorrectionCardEditConfirm", "aria-label": t('time_and_attendance_PunchCorrectionCard_CorrectionsConfirm_ariaLabel', {
                                date: punchCorrectionDate,
                                time: punchCorrectionTime
                            }) }, t('time_and_attendance_PunchCorrectionCard_CorrectionsConfirm')));
                    })))),
        react_1.default.createElement("div", { className: "atoz-dashed-line atoz-dashed-line--non-extended" })));
};
exports.PunchCorrectionCard = PunchCorrectionCard;
var StyledButton = (0, Theme_1.styledWithTheme)(Button_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: unset;\n"], ["\n    min-width: unset;\n"])));
var templateObject_1;
